import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Combobox } from '@flywire/react-headlessui';
import { useInputClasses } from '../Field';
import { useComboboxContext } from './Combobox';
const InputComponent = forwardRef(({ placeholder, className, position, ...rest }, ref) => {
    const { floatingLabel } = useComboboxContext();
    const inputClasses = useInputClasses({ floatingLabel, className, position });
    return (_jsx(Combobox.Input, { placeholder: placeholder, className: inputClasses, ref: ref, ...rest }));
});
InputComponent.displayName = 'Input';
export { InputComponent as Input };
//# sourceMappingURL=Input.js.map